import { AxiosError } from "axios";

type Err = string | Error | AxiosError | unknown;

function getFriendlyErrorMessage(err: Err): string | undefined;
function getFriendlyErrorMessage(err: Err, defaultMessage: string): string;
function getFriendlyErrorMessage(err: Err, defaultMessage?: string): unknown {
  let message: string | undefined;
  if (err instanceof Error) {
    //@ts-ignore
    if ((err as AxiosError)?.response?.data?.mensagem) {
      //@ts-ignore
      return (err as AxiosError).response!.data.mensagem as string;
      //@ts-ignore
    } else if ((err as AxiosError)?.response?.data?.message){
      //@ts-ignore
      return (err as AxiosError)?.response?.data?.message;
    } else {
      message = err.message
    }
  } else if (typeof err == 'string') {
    message = err
  }

  if (message) {
    return message;
  }

  return defaultMessage;
}

export default getFriendlyErrorMessage;